import { breakpoints } from '../../../styles/breakpoints';
import { Block, Box, transitionsDelay } from '../../../styles/basicStyles';
import styled from 'styled-components';
import Icon from '../../../components/icon';

export const HeaderWrapper = styled(Block)`
  border-radius: 0.5rem;
  background-color: rgba(129, 108, 255, 0.12);
  padding: 2rem;
  width: 100%;
  margin-bottom: 3.875rem;

  @media ${breakpoints.md} {
    margin-bottom: 3.5rem;
  }

  @media ${breakpoints.xs} {
    padding: 1.5rem 1rem;
  }
`;

export const FieldWrapper = styled(Block)`
  margin-bottom: 2.188rem;

  @media ${breakpoints.md} {
    margin-bottom: 1.5rem;
  }
`;

export const LinkedInWrapper = styled(Box)`
  position: absolute;
  background-color: ${({ theme }) => theme.colors.balticSea}; 
  height: 2rem;
  width: 2rem;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color ${transitionsDelay} linear;
  bottom: 0;
  right: -0.8rem;

  &:hover{
    background-color: ${({ theme }) => theme.colors.white};

    & svg {
      & path[stroke] {
        transition: stroke ${transitionsDelay} linear;
        stroke: ${({ theme }) =>  theme.colors.balticSea};
      }

      & path[fill] {
        transition: fill ${transitionsDelay} linear;
        fill: ${({ theme }) =>  theme.colors.balticSea};
      }
    }
  }
`;

export const UnderLineText = styled.span`
  text-decoration: underline;
  cursor: pointer;
  color: ${({ color, theme }) => color ? color : '#5747B2'}; 
`;

export const IconWrapper = styled(Icon)`
  display: unset;
  cursor: pointer;
`;

export const FormWrapper = styled(Block)`
  display: flex;
  flex-flow: row wrap;
  position: relative;
`;
